import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';
import { BaseForm } from 'projects/admin/src/app/classes/base-form';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { FormHelper } from 'projects/admin/src/app/shared/form-helper';
import { AcModel } from 'projects/core/src/lib/models/ac.model';
import { TodoModel } from 'projects/core/src/lib/models/todo.model';

class CustomTodoModel extends TodoModel {
  control: FormControl = new FormControl<boolean>(false);
  viewName: string;
}

@Component({
  selector: 'app-order-detail-todos',
  templateUrl: './order-detail-todos.component.html',
  styleUrl: './order-detail-todos.component.scss'
})
export class OrderDetailTodosComponent extends BaseForm implements OnInit, OnChanges {

  @Input() order: AcModel | null = null;

  @Output() orderChange = new EventEmitter<AcModel>();
  @Output() setEdit = new EventEmitter<string>();

  public todos: Array<CustomTodoModel> = [];

  constructor(
    private fb: FormBuilder,
    private auth: AuthStateService,
    private api: ApiService,
    private transloco: TranslocoService,
    private ui: UiService
  ) {
    super();
  }

  ngOnInit(): void {
    this.form = this.fb.group({});
    this.initTodos();
  }

  ngOnChanges(): void {
    if (this.form) {
      this.initTodos();
    }
  }

  public onEdit(): void {
    if (this.auth.hasRight('admin.template.edit')) {
      this.startEdit();
      this.setEdit.emit('todos');
    }
  }

  public onCancel(): void {
    this.initTodos();
    this.stopEdit();
  }

  public stopEdit(): void {
    this.inEdit = false;
    this.setEdit.emit(null);
  }

  public onSubmit(): void {
    this.ui.hideMessage();
    if (this.inEdit === true) {
      if (this.form.valid) {
        this.submitting = true;
        const payload = this.getPayload();
        this.api.saveOrderTodos(this.order.id, payload).subscribe({
          next: (result: any) => {
            this.ui.hideMessage();
            this.ui.toastSuccess(this.transloco.translate('order_todos.todos_saved'), this.transloco.translate('common.saved'));
            this.orderChange.emit(new AcModel().deserialize(result.data));
            this.stopEdit();
          },
          error: (error: any) => {
            this.ui.showMessage('error', this.transloco.translate(error.message), this.transloco.translate('common.error'));
          }
        }).add(() => {
          this.submitting = false;
        });
      } else {
        FormHelper.markFormAsDirty(this.form);
      }
    }
  }

  private getPayload(): any {
    const payload = this.todos.reduce((obj, todo: CustomTodoModel) => {
      obj[todo.id] = todo.control.value === true;
      return obj;
    }, {});
    return payload;
  }

  private initTodos(): void {
    const lang = this.transloco.getActiveLang().toUpperCase();
    this.todos = this.order?.todos?.map((todo: TodoModel) => {
      const customTodo = new CustomTodoModel().deserialize(todo);
      customTodo.viewName = todo.name[lang];
      customTodo.control = new FormControl<boolean>(todo.completed === true);
      return customTodo;
    });
  }

}
